import { render, staticRenderFns } from "./BottomStoryBlock.vue?vue&type=template&id=8e7288fc&scoped=true&"
import script from "./BottomStoryBlock.vue?vue&type=script&lang=js&"
export * from "./BottomStoryBlock.vue?vue&type=script&lang=js&"
import style0 from "./BottomStoryBlock.vue?vue&type=style&index=0&id=8e7288fc&scoped=true&lang=scss&"
import style1 from "./BottomStoryBlock.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e7288fc",
  null
  
)

export default component.exports